import { message, notification } from 'antd';
import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

function withHooks(Component) {
    return function WrappedComponent(props) {
        const navigate = useNavigate();
        const location = useLocation();
        const searchParams = new URLSearchParams(window.location.search);
        const [messageApi, contextHolder] = message.useMessage();
        const [notificationApi, notificationContextHolder] = notification.useNotification();

        return (
            <Component
                {...props}
                navigate={navigate}
                location={location}
                searchParams={searchParams}
                messageApi={messageApi}
                contextHolder={contextHolder}
                notificationApi={notificationApi}
                notificationContextHolder={notificationContextHolder}
            />
        );
    };
}

export default withHooks;
